<template>
  <div class="properties-field">
    <div class="wrap-properties">
      <!-- Header -->
      <div class="properties-field-title">
        <h4 class="title">External API</h4>
        <div
          class="close-properties"
          @click="$emit('close-config')"
        >
          &times;
        </div>
      </div>

      <!-- Content -->
      <div class="properties-field-content properties-field-content-config">
        <!-- Endpoint Section -->
        <div class="section-field input-field">
          <p class="title-section text-capitalize">Endpoint {{ typeTab }}</p>
          <b-row>
            <b-col cols="4">
              <b-form :class="{'error-input' : $v.dataSetup.method.$error}">
                <label> Method </label>
                <j-single-select
                  v-model="$v.dataSetup.method.$model"
                  :error-required="$v.dataSetup.method.$error"
                  :options="methodOptions"
                  :placeholder="'Select method'"
                  :disabled="['export'].includes(typeTab)"
                  label="label"/>
              </b-form>
            </b-col>

            <b-col cols="8">
              <b-form :class="{'error-input' : $v.dataSetup.url.$error}">
                <label> Url </label>
                <j-input
                  v-model="$v.dataSetup.url.$model"
                  :error-required="$v.dataSetup.url.$error"
                  placeholder="Enter url here"/>
              </b-form>
            </b-col>

            <b-col
              cols="12"
              class="mt-2"
            >
              <b-form
                v-if="!['import','export'].includes(typeTab)"
                :class="{'error-input' : $v.dataSetup.source.$error}">
                <label> Source </label>
                <j-input
                  v-model="$v.dataSetup.source.$model"
                  :error-required="$v.dataSetup.source.$error"
                  placeholder="Enter source here"/>
              </b-form>
            </b-col>

            <b-col
              cols="12"
              class="mt-2"
            >
              <b-form
                v-if="typeTab === 'list'"
                :class="{'error-input' : $v.dataSetup.source_count.$error}">
                <label> Source Count </label>
                <j-input
                  v-model="$v.dataSetup.source_count.$model"
                  :error-required="$v.dataSetup.source_count.$error"
                  placeholder="Enter source count here"/>
              </b-form>
            </b-col>
          </b-row>

          <!-- Header -->
          <p class="title-section mt-4">Header</p>
          <div
            v-for="(data, index) in dataSetup.header"
            :key="index + 0"
            class="form-list"
          >
            <input
              v-model="data.name"
              type="text"
              placeholder="Name"
              class="name"
            >
            <input
              v-model="data.value"
              type="text"
              placeholder="Value"
              class="value"
            >
            <i
              class="fa fa-trash"
              @click="deleteHeader(index)"
            />
          </div>
          <div
            class="btn-add-config"
            @click="addHeader">
            + Add Header
          </div>
        </div>

        <!-- Endpoint Search Section -->
        <div
          v-if="typeTab === 'export'"
          class="section-field input-field"
        >
          <p class="title-section">Endpoint Search</p>
          <b-row>
            <b-col cols="4">
              <b-form :class="{'error-input' : $v.dataSetup.method_search.$error}">
                <label> Method </label>
                <j-single-select
                  v-model="$v.dataSetup.method_search.$model"
                  :error-required="$v.dataSetup.method_search.$error"
                  :options="methodOptions"
                  :placeholder="'Select method'"
                  :disabled="true"
                  label="label"/>
              </b-form>
            </b-col>

            <b-col cols="8">
              <b-form :class="{'error-input' : $v.dataSetup.url_search.$error}">
                <label> Url </label>
                <j-input
                  v-model="$v.dataSetup.url_search.$model"
                  :error-required="$v.dataSetup.url_search.$error"
                  placeholder="Enter url here"/>
              </b-form>
            </b-col>
          </b-row>

          <!-- Header -->
          <p class="title-section mt-4">Header</p>
          <div
            v-for="(data, index) in dataSetup.header_search"
            :key="index + 0"
            class="form-list"
          >
            <input
              v-model="data.name"
              type="text"
              placeholder="Name"
              class="name"
            >
            <input
              v-model="data.value"
              type="text"
              placeholder="Value"
              class="value"
            >
            <i
              class="fa fa-trash"
              @click="deleteHeaderSearch(index)"
            />
          </div>
          <div
            class="btn-add-config"
            @click="addHeaderSearch">
            + Add Header
          </div>
        </div>

        <!-- Params Section -->
        <div
          v-if="dataSetup.method === 'GET' && !['import','export'].includes(typeTab)"
          class="section-field input-field"
        >
          <p class="title-section">Params</p>

          <div
            v-for="(data, index) in dataSetup.params"
            :key="index + 0"
            class="form-list"
          >
            <input
              v-model="data.variable"
              type="text"
              placeholder="Variable"
              class="name"
            >
            <input
              v-model="data.value"
              type="text"
              placeholder="Value"
              class="value"
            >
            <i
              class="fa fa-trash"
              @click="deleteParams(index)"
            />
          </div>
          <div
            class="btn-add-config"
            @click="addParams">
            + Add Params
          </div>
        </div>

        <!-- Paylaod Section -->
        <div
          v-else-if="!['import','export'].includes(typeTab)"
          class="section-field input-field"
        >
          <p class="title-section">Payload</p>

          <b-row v-if="showEditor">
            <b-col cols="12">
              <b-form>
                <label> Body </label>
                <j-monaco-editor
                  ref="scriptBody"
                  :value="dataSetup.payload.body"
                  height="200px"
                />
              </b-form>
            </b-col>
          </b-row>
        </div>

        <!-- Parse Variable Section -->
        <div
          v-if="!['import','export'].includes(typeTab)"
          class="section-field input-field">
          <div class="configuration-section">
            <p class="title-section">Parse Variable</p>
            <div
              v-for="(data, index) in dataSetup.variable"
              :key="index + 0"
              class="div-filter">
              <div class="header-filter">
                <div class="index">{{ index + 1 }}</div>
                <i
                  class="fa fa-trash"
                  @click="deleteVariable(index)"
                />
              </div>
              <b-form>
                <label> Variable </label>
                <j-single-select
                  v-model="data.variable"
                  :error-required="false"
                  :options="variableOptions"
                  placeholder="Select variable"
                />
              </b-form>
              <b-form>
                <label> Value </label>
                <j-input
                  v-model="data.value"
                  :error-required="false"
                  placeholder="Enter value here"
                />
              </b-form>
            </div>

            <div
              class="btn-add-config"
              @click="addVariable">
              + Add Variable
            </div>
          </div>

        </div>
      </div>

      <!-- Button -->
      <div class="properties-field-button justify-content-end">
        <div class="d-flex align-items-center">
          <button
            class="button-border mr-2"
            @click="$emit('close-config')"
          >
            Close
          </button>
          <button
            class="button-blue"
            @click="submitForm"
          >
            Set
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-nested-ternary, max-len, camelcase */
import { required, requiredIf } from 'vuelidate/lib/validators';
import draggable from 'vuedraggable';
import { mapActions, mapState } from 'vuex';
import jMixAutoScroll from '@/mixins/jMixAutoScroll';
import jMonacoEditor from '@/components/monaco-editor/jMonacoEditor';

export default {
  components: {
    draggable,
    jMonacoEditor,
  },
  mixins: [jMixAutoScroll],
  props: {
    typeTab: {
      type: String,
      default: '',
    },
    listVariable: {
      type: Array,
      default: () => [],
    },
    isMultipleForm: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showEditor: false,
      dataSetup: {
        method: null,
        method_search: null,
        url: null,
        url_search: null,
        source: null,
        source_count: null,
        header: [],
        header_search: [],
        params: [],
        variable: [],
        payload: {
          body: '',
        },
      },
      variableOptions: this.listVariable.map(e => ({
        id: e.name,
        text: e.name,
      })),
      methodOptions: [
        {
          id: 'GET',
          label: 'GET',
          text: 'GET',
        },
        {
          id: 'POST',
          label: 'POST',
          text: 'POST',
        },
        {
          id: 'PUT',
          label: 'PUT',
          text: 'PUT',
        },
        {
          id: 'PATCH',
          label: 'PATCH',
          text: 'PATCH',
        },
        {
          id: 'DELETE',
          label: 'DELETE',
          text: 'DELETE',
        },
      ],
      payloadOptions: [
        {
          id: 'raw',
          label: 'RAW',
          text: 'RAW',
        },
      ],
    };
  },

  computed: {
    ...mapState('jStoreFormUi', ['form_detail', 'multiple_form_detail']),
  },

  watch: {
    // eslint-disable-next-line func-names
    'dataSetup.method': function (val) {
      if (val !== 'GET') {
        setTimeout(() => {
          this.showEditor = true;
        }, 200);
      } else {
        this.showEditor = false;
      }
    },
  },

  created() {
    this.dataSetup.method = ['export'].includes(this.typeTab) ? 'GET' : null;
    this.dataSetup.method_search = ['export'].includes(this.typeTab) ? 'POST' : null;
    this.dataSetup.url = null;
    this.dataSetup.source = null;
    this.dataSetup.source_count = null;
    this.dataSetup.header = [];
    this.dataSetup.header_search = [];
    this.dataSetup.params = [];
    this.dataSetup.payload = {
      body: '',
    };

    const dataFormUi = this.isMultipleForm ? this.multiple_form_detail : this.form_detail;
    const dataDetail = dataFormUi[0].data_source ? dataFormUi[0].data_source.external_url : null;
    if (Object.keys(dataDetail[this.typeTab]).length) {
      // eslint-disable-next-line
      const { method, method_search, url, url_search, source, source_count, header, header_search, query_params, body, variables } = dataDetail[this.typeTab];
      this.dataSetup.method = ['export'].includes(this.typeTab) ? 'GET' : method;
      this.dataSetup.method_search = ['export'].includes(this.typeTab) ? 'POST' : method_search;
      this.dataSetup.url = url;
      this.dataSetup.url_search = url_search;
      this.dataSetup.source = source;
      this.dataSetup.source_count = source_count;
      this.dataSetup.payload.body = body;

      if (header) {
        const headerData = Object.keys(header);
        const headerValueData = Object.values(header);

        this.dataSetup.header = headerData.map((e, index) => ({
          name: e,
          value: headerValueData[index],
        }));
      }

      if (this.typeTab === 'export') {
        const headerSearchData = Object.keys(header_search);
        const headerValueSearchData = Object.values(header_search);
        this.dataSetup.header_search = headerSearchData.map((e, i) => ({
          name: e,
          value: headerValueSearchData[i],
        }));
      }

      const paramsData = Object.keys(query_params);
      const paramsValueData = Object.values(query_params);
      this.dataSetup.params = paramsData.map((e, index) => ({
        variable: e,
        value: paramsValueData[index],
      }));

      const variableData = Object.keys(variables);
      const variableValueData = Object.values(variables);
      this.dataSetup.variable = variableData.map((e, index) => ({
        variable: e,
        value: variableValueData[index],
      }));

      setTimeout(() => {
        if (this.dataSetup.method !== 'GET') {
          this.showEditor = true;
        }
      }, 200);
    }
  },
  methods: {
    ...mapActions('jStoreFormUi', ['actionGetDetailForm', 'actionGetDetailMultiForm', 'actionSetForm', 'actionSetMultiForm', 'actionGetFormDataList', 'actionGetDetailFormData']),

    addHeader() {
      this.dataSetup.header.push({
        name: null,
        value: null,
      });
    },
    deleteHeader(index) {
      this.dataSetup.header.splice(index, 1);
    },
    addHeaderSearch() {
      this.dataSetup.header_search.push({
        name: null,
        value: null,
      });
    },
    deleteHeaderSearch(index) {
      this.dataSetup.header_search.splice(index, 1);
    },
    addParams() {
      this.dataSetup.params.push({
        variable: null,
        value: null,
      });
    },
    deleteParams(index) {
      this.dataSetup.params.splice(index, 1);
    },
    addVariable() {
      this.dataSetup.variable.push({
        variable: null,
        value: null,
      });
    },
    deleteVariable(index) {
      this.dataSetup.variable.splice(index, 1);
    },
    async submitForm() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        const { method, method_search, url, url_search, source, source_count, header, header_search, params, variable } = this.dataSetup;

        // Data Source
        const dataFormUi = this.isMultipleForm ? this.multiple_form_detail : this.form_detail;
        const dataMasterSource = dataFormUi[0].data_source;
        const dataHeader = {};
        header.forEach((element) => {
          dataHeader[element.name] = element.value;
        });
        const dataSearchHeader = {};
        header_search.forEach((element) => {
          dataSearchHeader[element.name] = element.value;
        });
        const dataParams = {};
        params.forEach((element) => {
          dataParams[element.variable] = element.value;
        });
        const dataVariable = {};
        variable.forEach((element) => {
          dataVariable[element.variable] = element.value;
        });
        const newVal = {
          url,
          url_search,
          method,
          method_search,
          source,
          source_count,
          header: dataHeader,
          header_search: dataSearchHeader,
          query_params: dataParams,
          body: typeof this.$refs.scriptBody !== 'undefined' ? this.$refs.scriptBody.getData() : '',
          variables: dataVariable,
        };
        const dataSource = {
          external_url: {
            primary_key: dataMasterSource.external_url.primary_key,
            columns: dataMasterSource.external_url.columns,
            list: this.typeTab === 'list' ? newVal : (dataMasterSource ? dataMasterSource.external_url.list : {}),
            create: this.typeTab === 'create' ? newVal : (dataMasterSource ? dataMasterSource.external_url.create : {}),
            update: this.typeTab === 'update' ? newVal : (dataMasterSource ? dataMasterSource.external_url.update : {}),
            delete: this.typeTab === 'delete' ? newVal : (dataMasterSource ? dataMasterSource.external_url.delete : {}),
            detail: this.typeTab === 'detail' ? newVal : (dataMasterSource ? dataMasterSource.external_url.detail : {}),
            import: this.typeTab === 'import' ? newVal : (dataMasterSource ? dataMasterSource.external_url.import : {}),
            export: this.typeTab === 'export' ? newVal : (dataMasterSource ? dataMasterSource.external_url.export : {}),
          },
        };
        const param = this._.cloneDeep(dataFormUi[0]);
        param.type = 'external_url';
        param.data_source = dataSource;

        let res;
        if (!this.isMultipleForm) {
          res = await this.actionSetForm(param);
        } else {
          res = await this.actionSetMultiForm(param);
        }

        if (!res.error) {
          const dataFilter = {
            id: [this.$route.params.id],
          };
          const paramForm = {
            limit: 0,
            page: 1,
            filter: JSON.stringify(dataFilter),
          };
          if (this.isMultipleForm) {
            await this.actionGetDetailMultiForm(paramForm);
          } else {
            await this.actionGetDetailForm(paramForm);
          }
          this.$emit('close-config');
        }
      } else {
        this.scrollToErrorField('error-input');
      }
    },
  },
  validations() {
    return {
      dataSetup: {
        method: {
          required,
        },
        method_search: {
          required: requiredIf(() => this.typeTab === 'export'),
        },
        url: {
          required,
        },
        url_search: {
          required: requiredIf(() => this.typeTab === 'export'),
        },
        source: {
          required: requiredIf(() => this.typeTab === 'list'),
        },
        source_count: {
          required: requiredIf(() => this.typeTab === 'list'),
        },
        header: {},
        header_search: {},
        params: {},
        variable: {},
        payload: {
          body: {},
        },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/partials/ExternalApiForm.vue